import { rtkApi, GET_LOCATIONS } from '@/shared/api/rtkApi';
import {
  LocationsBulkActionRequest,
  LocationsBulkActionResponse,
  CreateLocationRequest,
  CreateLocationResponse,
  UpdateLocationRequest,
  UpdateLocationResponse,
  CreateRoomRequest,
  CreateRoomResponse,
  LocationDetailsParams,
  LocationDetailsResponse,
  LocationsParams,
  LocationsResponse,
  LocationsAllResponse,
  RoomsBulkDeleteRequest,
  RoomsBulkDeleteResponse,
  UpdateRoomRequest,
  UpdateRoomResponse,
} from './types';

export const locationsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getLocations: build.query<LocationsResponse, LocationsParams>({
      query: (params) => ({
        url: '/admin/locations',
        params,
      }),
      providesTags: [GET_LOCATIONS],
    }),
    getLocationsAll: build.query<LocationsAllResponse, void>({
      query: () => ({
        url: '/admin/locations/all',
      }),
      providesTags: [GET_LOCATIONS],
    }),
    getLocationById: build.query<LocationDetailsResponse, LocationDetailsParams>({
      query: ({ id, ...params }) => ({
        url: `/admin/locations/${id}`,
        params,
      }),
      providesTags: [GET_LOCATIONS],
    }),
    createLocation: build.mutation<CreateLocationResponse, CreateLocationRequest>({
      query: (body) => ({
        url: '/admin/locations',
        method: 'POST',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
    updateLocation: build.mutation<UpdateLocationResponse, { id: number; body: UpdateLocationRequest }>({
      query: ({ id, body }) => ({
        url: `/admin/locations/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
    createRoom: build.mutation<CreateRoomResponse, { id: number; body: CreateRoomRequest }>({
      query: ({ id, body }) => ({
        url: `/admin/locations/${id}/rooms`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
    updateRoom: build.mutation<UpdateRoomResponse, { id: number; body: UpdateRoomRequest }>({
      query: ({ id, body }) => ({
        url: `/admin/rooms/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
    bulkDeleteRooms: build.mutation<RoomsBulkDeleteResponse, RoomsBulkDeleteRequest>({
      query: (body) => ({
        url: '/admin/rooms/bulk-delete',
        method: 'POST',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
    blockLocations: build.mutation<LocationsBulkActionResponse, LocationsBulkActionRequest>({
      query: (body) => ({
        url: '/admin/locations/block',
        method: 'POST',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
    bulkDeleteLocations: build.mutation<LocationsBulkActionResponse, LocationsBulkActionRequest>({
      query: (body) => ({
        url: '/admin/locations/bulk-delete',
        method: 'POST',
        body,
      }),
      invalidatesTags: [GET_LOCATIONS],
    }),
  }),
});

export const {
  useGetLocationsQuery,
  useGetLocationsAllQuery,
  useGetLocationByIdQuery,
  useCreateLocationMutation,
  useUpdateLocationMutation,
  useCreateRoomMutation,
  useUpdateRoomMutation,
  useBulkDeleteRoomsMutation,
  useBlockLocationsMutation,
  useBulkDeleteLocationsMutation,
} = locationsApi;
